import ReportDom from "../../../../components/common/ReportDom";
import ServiceExpenseVoucherBody from "./components/ServiceExpenseVoucherBody";

export default function ServiceExpensePrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <ServiceExpenseVoucherBody service_ex_id={id} printMode />}
    />
  );
}
